import { useMotionValue, useTransform, motion, animate } from 'framer-motion'
import { useEffect } from 'react'

export interface TextCounterProps {
  from?: number
  to: number
  duration?: number
  delay?: number
  increment?: 'round' | 'decimal'
}

export const TextCounter = ({
  from = 0,
  to,
  duration = 1,
  delay,
  increment = 'round',
}: TextCounterProps) => {
  const count = useMotionValue(from)
  const num = useTransform(count, (latest: number) => {
    if (increment === 'decimal') return latest.toFixed(1)
    const counter = Math.round(latest)
    return counter.toString().padStart(2, counter > 0 ? '0' : '')
  })

  useEffect(() => {
    const controls = animate(count, to, { duration, delay, ease: 'easeOut' })
    return controls.stop
  }, [count, duration, delay, to])

  return <motion.span>{num}</motion.span>
}
